import React from "react"
import { Box } from "native-base"

const MainWrapp:React.FC<{children?: any}> = ({ children }) => {
    return (
        <Box flex={1} bg="white" alignItems="center">
            <Box w="100%" maxW="800px" px={5} py={10}>{children}</Box>
        </Box>
    )
}

export default React.memo(MainWrapp)